import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_import_inbound_shipment_request_payloadService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { ultrashipShipmentPayload?: string, messageStorageId?: string, messageTransactionId?: string }): Promise<{ responseResult?: $types.Ultraship.HttpRequestResponse, outputDetails?: string[], success?: boolean }> 
  {
    let url = `${environment.backendUrl}api/Ultraship/functions/import_inbound_shipment_request_payload`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

